function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import { __require as v } from "../../../color-name@1.1.4/node_modules/color-name/index.js";
var g, M;
function k() {
  if (M) return g;
  M = 1;
  var b = v(),
    m = {};
  for (var _i = 0, _Object$keys = Object.keys(b); _i < _Object$keys.length; _i++) {
    var n = _Object$keys[_i];
    m[b[n]] = n;
  }
  var l = {
    rgb: {
      channels: 3,
      labels: "rgb"
    },
    hsl: {
      channels: 3,
      labels: "hsl"
    },
    hsv: {
      channels: 3,
      labels: "hsv"
    },
    hwb: {
      channels: 3,
      labels: "hwb"
    },
    cmyk: {
      channels: 4,
      labels: "cmyk"
    },
    xyz: {
      channels: 3,
      labels: "xyz"
    },
    lab: {
      channels: 3,
      labels: "lab"
    },
    lch: {
      channels: 3,
      labels: "lch"
    },
    hex: {
      channels: 1,
      labels: ["hex"]
    },
    keyword: {
      channels: 1,
      labels: ["keyword"]
    },
    ansi16: {
      channels: 1,
      labels: ["ansi16"]
    },
    ansi256: {
      channels: 1,
      labels: ["ansi256"]
    },
    hcg: {
      channels: 3,
      labels: ["h", "c", "g"]
    },
    apple: {
      channels: 3,
      labels: ["r16", "g16", "b16"]
    },
    gray: {
      channels: 1,
      labels: ["gray"]
    }
  };
  g = l;
  for (var _i2 = 0, _Object$keys2 = Object.keys(l); _i2 < _Object$keys2.length; _i2++) {
    var _n = _Object$keys2[_i2];
    if (!("channels" in l[_n])) throw new Error("missing channels property: " + _n);
    if (!("labels" in l[_n])) throw new Error("missing channel labels property: " + _n);
    if (l[_n].labels.length !== l[_n].channels) throw new Error("channel and label counts mismatch: " + _n);
    var _l$_n = l[_n],
      c = _l$_n.channels,
      s = _l$_n.labels;
    delete l[_n].channels, delete l[_n].labels, Object.defineProperty(l[_n], "channels", {
      value: c
    }), Object.defineProperty(l[_n], "labels", {
      value: s
    });
  }
  l.rgb.hsl = function (n) {
    var c = n[0] / 255,
      s = n[1] / 255,
      t = n[2] / 255,
      e = Math.min(c, s, t),
      o = Math.max(c, s, t),
      r = o - e;
    var a, i;
    o === e ? a = 0 : c === o ? a = (s - t) / r : s === o ? a = 2 + (t - c) / r : t === o && (a = 4 + (c - s) / r), a = Math.min(a * 60, 360), a < 0 && (a += 360);
    var u = (e + o) / 2;
    return o === e ? i = 0 : u <= .5 ? i = r / (o + e) : i = r / (2 - o - e), [a, i * 100, u * 100];
  }, l.rgb.hsv = function (n) {
    var c, s, t, e, o;
    var r = n[0] / 255,
      a = n[1] / 255,
      i = n[2] / 255,
      u = Math.max(r, a, i),
      f = u - Math.min(r, a, i),
      h = function h(d) {
        return (u - d) / 6 / f + 1 / 2;
      };
    return f === 0 ? (e = 0, o = 0) : (o = f / u, c = h(r), s = h(a), t = h(i), r === u ? e = t - s : a === u ? e = 1 / 3 + c - t : i === u && (e = 2 / 3 + s - c), e < 0 ? e += 1 : e > 1 && (e -= 1)), [e * 360, o * 100, u * 100];
  }, l.rgb.hwb = function (n) {
    var c = n[0],
      s = n[1];
    var t = n[2];
    var e = l.rgb.hsl(n)[0],
      o = 1 / 255 * Math.min(c, Math.min(s, t));
    return t = 1 - 1 / 255 * Math.max(c, Math.max(s, t)), [e, o * 100, t * 100];
  }, l.rgb.cmyk = function (n) {
    var c = n[0] / 255,
      s = n[1] / 255,
      t = n[2] / 255,
      e = Math.min(1 - c, 1 - s, 1 - t),
      o = (1 - c - e) / (1 - e) || 0,
      r = (1 - s - e) / (1 - e) || 0,
      a = (1 - t - e) / (1 - e) || 0;
    return [o * 100, r * 100, a * 100, e * 100];
  };
  function y(n, c) {
    return Math.pow(n[0] - c[0], 2) + Math.pow(n[1] - c[1], 2) + Math.pow(n[2] - c[2], 2);
  }
  return l.rgb.keyword = function (n) {
    var c = m[n];
    if (c) return c;
    var s = 1 / 0,
      t;
    for (var _i3 = 0, _Object$keys3 = Object.keys(b); _i3 < _Object$keys3.length; _i3++) {
      var e = _Object$keys3[_i3];
      var o = b[e],
        r = y(n, o);
      r < s && (s = r, t = e);
    }
    return t;
  }, l.keyword.rgb = function (n) {
    return b[n];
  }, l.rgb.xyz = function (n) {
    var c = n[0] / 255,
      s = n[1] / 255,
      t = n[2] / 255;
    c = c > .04045 ? Math.pow((c + .055) / 1.055, 2.4) : c / 12.92, s = s > .04045 ? Math.pow((s + .055) / 1.055, 2.4) : s / 12.92, t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92;
    var e = c * .4124 + s * .3576 + t * .1805,
      o = c * .2126 + s * .7152 + t * .0722,
      r = c * .0193 + s * .1192 + t * .9505;
    return [e * 100, o * 100, r * 100];
  }, l.rgb.lab = function (n) {
    var c = l.rgb.xyz(n);
    var s = c[0],
      t = c[1],
      e = c[2];
    s /= 95.047, t /= 100, e /= 108.883, s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116, t = t > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, e = e > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116;
    var o = 116 * t - 16,
      r = 500 * (s - t),
      a = 200 * (t - e);
    return [o, r, a];
  }, l.hsl.rgb = function (n) {
    var c = n[0] / 360,
      s = n[1] / 100,
      t = n[2] / 100;
    var e, o, r;
    if (s === 0) return r = t * 255, [r, r, r];
    t < .5 ? e = t * (1 + s) : e = t + s - t * s;
    var a = 2 * t - e,
      i = [0, 0, 0];
    for (var u = 0; u < 3; u++) o = c + 1 / 3 * -(u - 1), o < 0 && o++, o > 1 && o--, 6 * o < 1 ? r = a + (e - a) * 6 * o : 2 * o < 1 ? r = e : 3 * o < 2 ? r = a + (e - a) * (2 / 3 - o) * 6 : r = a, i[u] = r * 255;
    return i;
  }, l.hsl.hsv = function (n) {
    var c = n[0];
    var s = n[1] / 100,
      t = n[2] / 100,
      e = s;
    var o = Math.max(t, .01);
    t *= 2, s *= t <= 1 ? t : 2 - t, e *= o <= 1 ? o : 2 - o;
    var r = (t + s) / 2,
      a = t === 0 ? 2 * e / (o + e) : 2 * s / (t + s);
    return [c, a * 100, r * 100];
  }, l.hsv.rgb = function (n) {
    var c = n[0] / 60,
      s = n[1] / 100;
    var t = n[2] / 100;
    var e = Math.floor(c) % 6,
      o = c - Math.floor(c),
      r = 255 * t * (1 - s),
      a = 255 * t * (1 - s * o),
      i = 255 * t * (1 - s * (1 - o));
    switch (t *= 255, e) {
      case 0:
        return [t, i, r];
      case 1:
        return [a, t, r];
      case 2:
        return [r, t, i];
      case 3:
        return [r, a, t];
      case 4:
        return [i, r, t];
      case 5:
        return [t, r, a];
    }
  }, l.hsv.hsl = function (n) {
    var c = n[0],
      s = n[1] / 100,
      t = n[2] / 100,
      e = Math.max(t, .01);
    var o, r;
    r = (2 - s) * t;
    var a = (2 - s) * e;
    return o = s * e, o /= a <= 1 ? a : 2 - a, o = o || 0, r /= 2, [c, o * 100, r * 100];
  }, l.hwb.rgb = function (n) {
    var c = n[0] / 360;
    var s = n[1] / 100,
      t = n[2] / 100;
    var e = s + t;
    var o;
    e > 1 && (s /= e, t /= e);
    var r = Math.floor(6 * c),
      a = 1 - t;
    o = 6 * c - r, (r & 1) !== 0 && (o = 1 - o);
    var i = s + o * (a - s);
    var u, f, h;
    switch (r) {
      default:
      case 6:
      case 0:
        u = a, f = i, h = s;
        break;
      case 1:
        u = i, f = a, h = s;
        break;
      case 2:
        u = s, f = a, h = i;
        break;
      case 3:
        u = s, f = i, h = a;
        break;
      case 4:
        u = i, f = s, h = a;
        break;
      case 5:
        u = a, f = s, h = i;
        break;
    }
    return [u * 255, f * 255, h * 255];
  }, l.cmyk.rgb = function (n) {
    var c = n[0] / 100,
      s = n[1] / 100,
      t = n[2] / 100,
      e = n[3] / 100,
      o = 1 - Math.min(1, c * (1 - e) + e),
      r = 1 - Math.min(1, s * (1 - e) + e),
      a = 1 - Math.min(1, t * (1 - e) + e);
    return [o * 255, r * 255, a * 255];
  }, l.xyz.rgb = function (n) {
    var c = n[0] / 100,
      s = n[1] / 100,
      t = n[2] / 100;
    var e, o, r;
    return e = c * 3.2406 + s * -1.5372 + t * -.4986, o = c * -.9689 + s * 1.8758 + t * .0415, r = c * .0557 + s * -.204 + t * 1.057, e = e > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : e * 12.92, o = o > .0031308 ? 1.055 * Math.pow(o, 1 / 2.4) - .055 : o * 12.92, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : r * 12.92, e = Math.min(Math.max(0, e), 1), o = Math.min(Math.max(0, o), 1), r = Math.min(Math.max(0, r), 1), [e * 255, o * 255, r * 255];
  }, l.xyz.lab = function (n) {
    var c = n[0],
      s = n[1],
      t = n[2];
    c /= 95.047, s /= 100, t /= 108.883, c = c > .008856 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116, s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116, t = t > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116;
    var e = 116 * s - 16,
      o = 500 * (c - s),
      r = 200 * (s - t);
    return [e, o, r];
  }, l.lab.xyz = function (n) {
    var c = n[0],
      s = n[1],
      t = n[2];
    var e, o, r;
    o = (c + 16) / 116, e = s / 500 + o, r = o - t / 200;
    var a = Math.pow(o, 3),
      i = Math.pow(e, 3),
      u = Math.pow(r, 3);
    return o = a > .008856 ? a : (o - 16 / 116) / 7.787, e = i > .008856 ? i : (e - 16 / 116) / 7.787, r = u > .008856 ? u : (r - 16 / 116) / 7.787, e *= 95.047, o *= 100, r *= 108.883, [e, o, r];
  }, l.lab.lch = function (n) {
    var c = n[0],
      s = n[1],
      t = n[2];
    var e;
    e = Math.atan2(t, s) * 360 / 2 / Math.PI, e < 0 && (e += 360);
    var r = Math.sqrt(s * s + t * t);
    return [c, r, e];
  }, l.lch.lab = function (n) {
    var c = n[0],
      s = n[1],
      e = n[2] / 360 * 2 * Math.PI,
      o = s * Math.cos(e),
      r = s * Math.sin(e);
    return [c, o, r];
  }, l.rgb.ansi16 = function (n) {
    var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _n2 = _slicedToArray(n, 3),
      s = _n2[0],
      t = _n2[1],
      e = _n2[2];
    var o = c === null ? l.rgb.hsv(n)[2] : c;
    if (o = Math.round(o / 50), o === 0) return 30;
    var r = 30 + (Math.round(e / 255) << 2 | Math.round(t / 255) << 1 | Math.round(s / 255));
    return o === 2 && (r += 60), r;
  }, l.hsv.ansi16 = function (n) {
    return l.rgb.ansi16(l.hsv.rgb(n), n[2]);
  }, l.rgb.ansi256 = function (n) {
    var c = n[0],
      s = n[1],
      t = n[2];
    return c === s && s === t ? c < 8 ? 16 : c > 248 ? 231 : Math.round((c - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(c / 255 * 5) + 6 * Math.round(s / 255 * 5) + Math.round(t / 255 * 5);
  }, l.ansi16.rgb = function (n) {
    var c = n % 10;
    if (c === 0 || c === 7) return n > 50 && (c += 3.5), c = c / 10.5 * 255, [c, c, c];
    var s = (~~(n > 50) + 1) * .5,
      t = (c & 1) * s * 255,
      e = (c >> 1 & 1) * s * 255,
      o = (c >> 2 & 1) * s * 255;
    return [t, e, o];
  }, l.ansi256.rgb = function (n) {
    if (n >= 232) {
      var o = (n - 232) * 10 + 8;
      return [o, o, o];
    }
    n -= 16;
    var c;
    var s = Math.floor(n / 36) / 5 * 255,
      t = Math.floor((c = n % 36) / 6) / 5 * 255,
      e = c % 6 / 5 * 255;
    return [s, t, e];
  }, l.rgb.hex = function (n) {
    var s = (((Math.round(n[0]) & 255) << 16) + ((Math.round(n[1]) & 255) << 8) + (Math.round(n[2]) & 255)).toString(16).toUpperCase();
    return "000000".substring(s.length) + s;
  }, l.hex.rgb = function (n) {
    var c = n.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!c) return [0, 0, 0];
    var s = c[0];
    c[0].length === 3 && (s = s.split("").map(function (a) {
      return a + a;
    }).join(""));
    var t = parseInt(s, 16),
      e = t >> 16 & 255,
      o = t >> 8 & 255,
      r = t & 255;
    return [e, o, r];
  }, l.rgb.hcg = function (n) {
    var c = n[0] / 255,
      s = n[1] / 255,
      t = n[2] / 255,
      e = Math.max(Math.max(c, s), t),
      o = Math.min(Math.min(c, s), t),
      r = e - o;
    var a, i;
    return r < 1 ? a = o / (1 - r) : a = 0, r <= 0 ? i = 0 : e === c ? i = (s - t) / r % 6 : e === s ? i = 2 + (t - c) / r : i = 4 + (c - s) / r, i /= 6, i %= 1, [i * 360, r * 100, a * 100];
  }, l.hsl.hcg = function (n) {
    var c = n[1] / 100,
      s = n[2] / 100,
      t = s < .5 ? 2 * c * s : 2 * c * (1 - s);
    var e = 0;
    return t < 1 && (e = (s - .5 * t) / (1 - t)), [n[0], t * 100, e * 100];
  }, l.hsv.hcg = function (n) {
    var c = n[1] / 100,
      s = n[2] / 100,
      t = c * s;
    var e = 0;
    return t < 1 && (e = (s - t) / (1 - t)), [n[0], t * 100, e * 100];
  }, l.hcg.rgb = function (n) {
    var c = n[0] / 360,
      s = n[1] / 100,
      t = n[2] / 100;
    if (s === 0) return [t * 255, t * 255, t * 255];
    var e = [0, 0, 0],
      o = c % 1 * 6,
      r = o % 1,
      a = 1 - r;
    var i = 0;
    switch (Math.floor(o)) {
      case 0:
        e[0] = 1, e[1] = r, e[2] = 0;
        break;
      case 1:
        e[0] = a, e[1] = 1, e[2] = 0;
        break;
      case 2:
        e[0] = 0, e[1] = 1, e[2] = r;
        break;
      case 3:
        e[0] = 0, e[1] = a, e[2] = 1;
        break;
      case 4:
        e[0] = r, e[1] = 0, e[2] = 1;
        break;
      default:
        e[0] = 1, e[1] = 0, e[2] = a;
    }
    return i = (1 - s) * t, [(s * e[0] + i) * 255, (s * e[1] + i) * 255, (s * e[2] + i) * 255];
  }, l.hcg.hsv = function (n) {
    var c = n[1] / 100,
      s = n[2] / 100,
      t = c + s * (1 - c);
    var e = 0;
    return t > 0 && (e = c / t), [n[0], e * 100, t * 100];
  }, l.hcg.hsl = function (n) {
    var c = n[1] / 100,
      t = n[2] / 100 * (1 - c) + .5 * c;
    var e = 0;
    return t > 0 && t < .5 ? e = c / (2 * t) : t >= .5 && t < 1 && (e = c / (2 * (1 - t))), [n[0], e * 100, t * 100];
  }, l.hcg.hwb = function (n) {
    var c = n[1] / 100,
      s = n[2] / 100,
      t = c + s * (1 - c);
    return [n[0], (t - c) * 100, (1 - t) * 100];
  }, l.hwb.hcg = function (n) {
    var c = n[1] / 100,
      t = 1 - n[2] / 100,
      e = t - c;
    var o = 0;
    return e < 1 && (o = (t - e) / (1 - e)), [n[0], e * 100, o * 100];
  }, l.apple.rgb = function (n) {
    return [n[0] / 65535 * 255, n[1] / 65535 * 255, n[2] / 65535 * 255];
  }, l.rgb.apple = function (n) {
    return [n[0] / 255 * 65535, n[1] / 255 * 65535, n[2] / 255 * 65535];
  }, l.gray.rgb = function (n) {
    return [n[0] / 100 * 255, n[0] / 100 * 255, n[0] / 100 * 255];
  }, l.gray.hsl = function (n) {
    return [0, 0, n[0]];
  }, l.gray.hsv = l.gray.hsl, l.gray.hwb = function (n) {
    return [0, 100, n[0]];
  }, l.gray.cmyk = function (n) {
    return [0, 0, 0, n[0]];
  }, l.gray.lab = function (n) {
    return [n[0], 0, 0];
  }, l.gray.hex = function (n) {
    var c = Math.round(n[0] / 100 * 255) & 255,
      t = ((c << 16) + (c << 8) + c).toString(16).toUpperCase();
    return "000000".substring(t.length) + t;
  }, l.rgb.gray = function (n) {
    return [(n[0] + n[1] + n[2]) / 3 / 255 * 100];
  }, g;
}
export { k as __require };